import { useEffect } from "react";
import { lockBodyScroll, unlockBodyScroll } from "../utils/bodyScrollLock";

export function useBodyScrollLock(locked) {
  useEffect(() => {
    if (!locked) return undefined;

    lockBodyScroll();
    return () => unlockBodyScroll();
  }, [locked]);
}
